import { render, staticRenderFns } from "./MarketGroupModal.vue?vue&type=template&id=2c5d4c16&scoped=true&"
import script from "./MarketGroupModal.vue?vue&type=script&lang=js&"
export * from "./MarketGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d4c16",
  null
  
)

export default component.exports